// src/components/ModalSelectInput.js
import React, { useState } from 'react';
import Modal from './Modal';
import { FiCheck, FiChevronDown } from 'react-icons/fi';

const ModalSelectInput = ({ name, label, options, value, onChange, placeholder = "Select an option", disabled = false, className = "form-input" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectedOption = options.find(o => String(o.value) === String(value));

    const handleSelect = (val) => {
        if (onChange) {
            // Triggers a synthetic event wrapper to match standard input 'onChange' signatures
            onChange({ target: { name, value: val } }, val);
        }
        setIsOpen(false);
    };

    return (
        <>
            <div 
                className={`${className} ${disabled ? 'disabled' : ''}`}
                style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    backgroundColor: disabled ? 'var(--gray-100)' : 'var(--white)',
                    color: selectedOption ? 'var(--gray-800)' : 'var(--gray-500)',
                    opacity: disabled ? 0.7 : 1,
                    userSelect: 'none'
                }}
                onClick={() => !disabled && setIsOpen(true)}
            >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {selectedOption ? selectedOption.label : placeholder}
                </span>
                <FiChevronDown style={{ flexShrink: 0, marginLeft: '0.5rem', color: 'var(--gray-400)' }} />
            </div>
            
            <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} title={label || "Select Option"} size="slim">
                <div className="selection-list" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {options.map(option => {
                        const isSelected = String(value) === String(option.value);
                        return (
                            <div 
                                key={option.value} 
                                className={`selection-list-item ${isSelected ? 'selected' : ''}`}
                                onClick={() => handleSelect(option.value)}
                            >
                                <div className="item-main-info">
                                    <p className="item-title">{option.label}</p>
                                </div>
                                <div className="item-meta-info">
                                    {isSelected && <FiCheck className="selection-checkmark" />}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Modal>
        </>
    );
};

export default ModalSelectInput;